export enum SettingsActionTypes {
	SET_LOCATION = "SETTINGS/SET_LOCATION",
	SET_PIN_CODE = "SETTINGS/SET_PIN_CODE",
	SET_PRINTER_IP = "SETTINGS/SET_PRINTER_IP",
	SET_MASTER_PASSWORD_RESULT = "SETTINGS/SET_MASTER_PASSWORD_RESULT",
}
